import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MedReviewService } from '../../services/med-review.service';

@Component({
  selector: 'kt-drp-dashboard-body',
  templateUrl: './drp-dashboard-body.component.html',
  styleUrls: ['./drp-dashboard-body.component.scss'],
})
export class DrpDashboardBodyComponent implements OnInit {
  selectedKey = '';
  medications = [];
  constructor(private medReviewService: MedReviewService, public dialog: MatDialog) {}

  @Input() patient;
  drpStatuses = {
    potential: 'Potential',
    active: 'Active',
    resolved: 'Resolved',
    future_review: 'Future Review',
  };
  drpCounts = {
    potential: 0,
    active: 0,
    resolved: 0,
    future_review: 0,
  };

  statusesKeys = ['potential', 'active', 'resolved', 'future_review'];

  statusData = {
    potential: [],
    active: [],
    resolved: [],
    future_review: [],
  };

  ngOnInit(): void {
    this.getDrpCount();
    this.getDRPByStatus('potential');
  }

  getDrpCount() {
    this.medReviewService.getDrpCount(this.patient.id).subscribe((result) => {
      this.drpCounts = {
        potential: result['potential'],
        active: result['active'],
        resolved: result['resolved'],
        future_review: result['future_review'],
      };
    });
  }

  getDRPByStatus(status) {
    this.selectedKey = status;
    let element = '';
    if (status === 'active') {
      element = 'ACTIVE';
    }
    if (status === 'resolved') {
      element = 'RESOLVED';
    }
    if (status === 'future_review') {
      element = 'PENDING';
    }
    this.medReviewService.getDrps(this.patient.id, element).subscribe((res) => {
      this.statusData[status] = res;
      const drug_codes = [];
      res.forEach((drp) => drug_codes.push(drp.drug_code));
      this.getMedications(drug_codes);
    });
  }
  getMedications(codes) {
    if (codes.length > 0)
      this.medReviewService.getDrugByNDC(codes).subscribe((res) => {
        this.medications = res.data;
      });
  }
}
